import * as React from 'react';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';

export interface Props {
    small?: boolean,
    onFileUpload: (files: FileList) => void,
}

export interface State {
    disabled: boolean;
}

export default class FileUploadButton extends React.Component<Props, State> {
    constructor(props, context) {
        super(props, context);
        this.state = {
            disabled: false
        }

        this.onFileClick = this.onFileClick.bind(this);
        this.onFileUpload = this.onFileUpload.bind(this);

    }

    async componentDidMount() {
    }
    
    onFileUpload = async (event) => {

        let files = event.target.files;

        this.setState({ disabled: true }, async () => {


            if (files.length != 1) {
                return;
            }
            
            await this.props.onFileUpload(files);

            // component will be re-created
            // this.setState({ disabled: false });
        });
    }

    onFileClick = (event) => {
        event.target.value = null
    }

    render() {
        const {
            small,
        } = this.props;
        const {
            disabled,
        } = this.state;

        const largeStyle = {
            "width": "100%",
            "height": "30px",
            
        };

        const largeStyleInput = {
            ...largeStyle,
            "overflow":"hidden"
        }

        const smallStyle = {
            "width": "80px",
            "height": "25px",
            "fontSize": "12px",
            "padding": "0",
            "overflow": "hidden",
        };

        const smallStyleDiv = {
            ...smallStyle,
            "marginTop": ".25rem",
        }

        const buttonContent = <span style={small ? { "fontWeight": 400 } : null}>{disabled ? "Please wait..." : (small ? "Replace file" : "Upload a spreadsheet to start")}</span>


        return (
            <div className='mm-fileUploadButton' style={small ? smallStyleDiv : largeStyle}>
                <input
                    disabled={disabled}
                    type="file"
                    id="files"
                    onChange={this.onFileUpload}
                    onClick={this.onFileClick}
                    style={largeStyleInput}
                />
                {small ?
                    <DefaultButton disabled={disabled} style={small ? smallStyle : largeStyle}>
                        {buttonContent}
                    </DefaultButton> :
                    <PrimaryButton disabled={disabled} style={small ? smallStyle : largeStyle}>
                        {buttonContent}
                    </PrimaryButton>
                }
            </div>
        );
    }
}
